import React from "react";
import styled from "styled-components";

const Vessel = styled.div`
  & > #screen-size-renderer-desktop {
    display: contents;
  }
  & > #screen-size-renderer-mobile {
    display: none;
  }

  @media only screen and (max-width: ${(props) => props.threshold}px) {
    & > #screen-size-renderer-desktop {
      display: none;
    }
    & > #screen-size-renderer-mobile {
      display: contents;
    }
  }
`;

const ScreenSizeRenderer = ({
  threshold,
  children,
}) => {
  return (
    <Vessel threshold={threshold || 800}>
      <div id="screen-size-renderer-desktop">{children?.[0]}</div>
      <div id="screen-size-renderer-mobile">{children?.[1]}</div>
    </Vessel>
  );
};

export default ScreenSizeRenderer;
